import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import DefaultProfileAvatar from "../../assets/profile_avatar.png";

export type MembershipBadgeType = "normal" | "silver" | "golden" | "platinium";

type Props = {
  src?: string | null;
  badgeType?: MembershipBadgeType;
  alt?: string;
  className?: string;
};

const MembershipAvatar = ({
  src,
  badgeType = "normal",
  alt = "",
  className,
}: Props) => {
  const { t } = useTranslation();
  const resolvedSrc =
    src && typeof src === "string" ? src : DefaultProfileAvatar;
  const badgeLabel = t(`profile.badge.${badgeType}`);

  return (
    <div
      className={[
        "ac-profile-sidebar__avatar",
        `ac-profile-sidebar__avatar--${badgeType}`,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="ac-membership-avatar">
        <img
          className="ac-membership-avatar__img"
          src={resolvedSrc}
          alt={alt}
          loading="lazy"
          decoding="async"
          onError={(e) => {
            const img = e.currentTarget;
            if (img.src !== DefaultProfileAvatar) img.src = DefaultProfileAvatar;
          }}
        />
      </div>
      <Tooltip
        title={badgeLabel}
        overlayClassName="ac--share-tooltip ac-membership-avatar__tooltip"
        placement="bottom"
      >
       
      </Tooltip>
    </div>
  );
};

export default MembershipAvatar;
